// src/components/icons/BackIcon.js
import React from 'react';

/**
 * BackIcon — traced directly from the original back.png asset.
 * Uses fill="currentColor" so it inherits the parent element's CSS `color`
 * property, making it fully themeable via --color-buttons.
 */
const BackIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 107.661310 111.885383"
    fill="currentColor"
    className={className}
  >
    <g
      transform="translate(-17.430664,125.885383) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path d="M685 1250 c-33 -13 -489 -477 -503 -511 -24 -57 -7 -80 261 -347 239 -238 255 -252 290 -252 26 0 46 8 72 31 30 27 35 37 35 74 0 52 -2 55 -169 220 -66 66 -121 123 -121 127 0 4 147 9 326 10 l326 3 24 30 c35 44 33 103 -5 144 l-29 31 -321 0 c-177 0 -321 3 -321 7 0 4 63 71 140 148 135 137 140 143 140 184 0 51 -21 86 -62 100 -36 13 -55 13 -83 1z"/>
    </g>
  </svg>
);

export default BackIcon;
